import { useTableOfContentsItems } from "../../hooks/tableOfContentsHooks/useTableOfContentsItems";
import styles from "./TableOfContentsMenu.module.scss";
import TableOfContentsList from "./TableOfContentsList";
import { useTableOfContents } from "../../hooks/tableOfContentsHooks/useTableOfContents";
import { getTocName } from "../../utils/getTocName";
import useTopicSidebarToggle from "../../hooks/useTopicSidebarToggle";
import classNames from "classnames";

const TableOfContentsSideMenu = ({ msPath }) => {
  useTableOfContentsItems(msPath);
  const tocContext = useTableOfContents();
  const { isOpen, toggleSidebar } = useTopicSidebarToggle();

  const handleMouseEnter = (event) => {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();

    const tooltipTop = rect.bottom + 8;
    const tooltipLeft = rect.right - 64;

    button.style.setProperty("--tooltip-top", `${tooltipTop}px`);
    button.style.setProperty("--tooltip-left", `${Math.max(8, tooltipLeft)}px`); // Keep at least 8px from left edge
  };

  return (
    <div aria-label="Table of Contents Side Menu" className={styles.sidebarContainer}>
      {/* Always show toggle button - positioned aligned with search box center */}
      <button
        className={classNames(styles.toggleButton, !isOpen && styles.buttonClosed)}
        onClick={toggleSidebar}
        onMouseEnter={handleMouseEnter}
        aria-label={isOpen ? "Collapse sidebar" : "Expand sidebar"}
        data-tooltip={isOpen ? "Close sidebar" : "Open sidebar"}
      >
        <i
          className={classNames(
            "tg-icons-ChevronDown",
            styles.chevronIcon,
            isOpen ? styles.open : styles.closed,
          )}
        ></i>
      </button>
      {/* Sidebar content - only show when open */}
      {isOpen && (
        <div className={styles.header}>
          <div className={styles.topicTitle}>
            <h1>
              {(tocContext.umbrellaNode && tocContext.umbrellaNode?.title) || getTocName(msPath)}
            </h1>
          </div>

          <div className={styles.title}>
            <h3>{tocContext.tableOfContents?.title}</h3>
          </div>
        </div>
      )}

      {isOpen && (
        <div className={styles.content}>
          {tocContext.tableOfContents?.children?.length > 0 && (
            <TableOfContentsList items={tocContext.tableOfContents.children} />
          )}
        </div>
      )}
    </div>
  );
};

export default TableOfContentsSideMenu;
